module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td>Пространственно-временная протяженность</td>\n			<td><control type=\"text\" target=\"item.description\"/></td>\n		</tr>\n		<tr>\n			<td colspan=\"2\">\n				<div class=\"title\">Географические идентификаторы</div>\n				<div class=\"extent-geogdesc\"></div>\n				<div class=\"buttons\"><button on-click=\"addGeogDesc\">Добавить</button></div>\n			</td>\n		</tr>\n		<tr>\n			<td colspan=\"2\">\n				<div class=\"title\">Географические координаты</div>\n				<div class=\"extent-boundingboxes\"></div>\n				<div class=\"buttons\"><button on-click=\"addBoundingBox\">Добавить</button></div>\n			</td>\n		</tr>\n		<tr>\n			<td colspan=\"2\">\n				<div class=\"title\">Высотные компоненты</div>\n				<div class=\"extent-verticalextents\"></div>\n				<div class=\"buttons\"><button on-click=\"addVerticalExtent\">Добавить</button></div>\n			</td>\n		</tr>\n		<tr>\n			<td colspan=\"2\">\n				<div class=\"title\">Временные компоненты</div>\n				<div class=\"extent-temporalextents\"></div>\n				<div class=\"buttons\"><button on-click=\"addTemporalExtent\">Добавить</button></div>\n			</td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}